import React, { useEffect } from "react";
import { Router } from "@reach/router";
import { Login } from "./components/pages/Login";
import { Authenticated } from "./components/helpers";
import { OnboardingWrapper } from "./components/pages/Onboarding/Onboarding";
import MainSection from "./components/pages/MainSection/MainSection";
import { useFetcher } from "rest-hooks";
import { LoginResource } from "./resources";

function App() {
	return (
		<Router>
			<Login path="/login/*" />
			<Logout path="/logout" />

			<Authenticated default>
				<OnboardingWrapper default>
					<MainSection default />
				</OnboardingWrapper>
			</Authenticated>
		</Router>
	);
}

const Logout = ({ navigate }) => {
	const logout = useFetcher(LoginResource.logoutShape());
	useEffect(() => {
		async function logoutAndRedirect() {
			const { isAuthenticated } = await logout();
			// force reload to clear out application-cache (rest-hooks)
			if (!isAuthenticated) window.location.href = "/";
		}
		logoutAndRedirect();
	}, [logout, navigate]);
	return null;
};

export default App;
